<div *ngFor="let owner of owners">
    <ul class="ownerslist">
        <li class="name_block">{{owner.name}}
            <img *ngIf="owner.ownerinformation.aadhaarverified"  src="../../assets/Aadhar-Black.svg" alt="Aadhaar Verified" style="width: 32px; height: auto; margin-left: 10px;  vertical-align: middle;">
        </li>
        <li class="status_block">{{owner.ownertype.OwnershipTypeName}}</li>
        <li class="share_block">{{owner.ownershippercentage}} %</li>
        <li class="button_block">
            <input class="appButton" style="font-size: 18px;" type="button" value="View details" (click)="onDetailsClicked(owner)">
        </li>
        <li class="clearfix"></li>
    </ul>

</div>
